import { isHtmlContentEmpty } from '@/common/helpers/helpers'
import { exchangeMethods } from '@/configuration/pages/ConfigurationPage/constants'

import { issueExchangeStatus } from '../constants'
import { brokenDiscountHandlingValues } from './DiscountsConfiguration/constants'
import { exchangeOrdersAutomaticCreationValues, MAX_RETURN_CANCEL_DEADLINE_DAYS } from './constants'

export const getPayload = ({
  allowReturns,
  maxDurationForRefund,
  shippingIncluded,
  allowExchanges,
  maxDurationForExchanges,
  allowedExchangeMethods,
  exchangeOrdersAutomaticCreation,
  allowInstantExchanges,
  instantExchangeOrdersAutomaticCreation,
  allowEvenExchangesCatalogPrice,
  issueExchangeAtStatus,
  exchangeOrdersSendProviderNotification,
  instantExchangeOrdersSendProviderNotification,
  exchangeErrorResolution,
  returnCancelDeadlineDays,
  manageRestock,
  refundReferenceDate,
  exchangeReferenceDate,
  bundleReturnPolicy,
  bundleAllowedRequests,
  buyXGetYReturnPolicy,
  brokenDiscountHandling,
  brokenDiscountBonusEnabled,
  brokenDiscountCustomMessageEnabled,
  brokenDiscountCustomMessage,
  exchangePaymentExpiration,
  instantExchangePaymentExpiration,
  allowsGiftReturns,
  skipIdentifierValidation,
}) => {
  return {
    allows_refunds: allowReturns,
    max_duration_for_refund: `${maxDurationForRefund} 00:00:00`,
    shipping_included: shippingIncluded,
    allows_exchanges: allowExchanges,
    max_duration_for_exchange: `${maxDurationForExchanges} 00:00:00`,
    exchange_orders_automatic_creation:
      exchangeOrdersAutomaticCreation === exchangeOrdersAutomaticCreationValues.automatic,
    allows_instant_exchanges: allowInstantExchanges,
    instant_exchange_orders_automatic_creation:
      instantExchangeOrdersAutomaticCreation === exchangeOrdersAutomaticCreationValues.automatic,
    allowed_exchange_methods: allowedExchangeMethods,
    allow_even_exchanges_catalog_price: allowEvenExchangesCatalogPrice,
    issue_exchange_at_status:
      exchangeOrdersAutomaticCreation === exchangeOrdersAutomaticCreationValues.automatic
        ? issueExchangeAtStatus
        : null,
    exchange_orders_send_provider_notification: exchangeOrdersSendProviderNotification,
    instant_exchange_orders_send_provider_notification: instantExchangeOrdersSendProviderNotification,
    exchange_error_resolution: exchangeErrorResolution,
    return_cancel_deadline_days: returnCancelDeadlineDays ? Number(returnCancelDeadlineDays) : null,
    manage_restock: manageRestock,
    refund_reference_date: refundReferenceDate,
    exchange_reference_date: exchangeReferenceDate,
    bundle_return_policy: bundleReturnPolicy,
    bundle_allowed_requests: bundleAllowedRequests,
    buyxgety_return_policy: buyXGetYReturnPolicy,
    broken_discount_handling: brokenDiscountHandling,
    broken_discount_bonus_enabled:
      brokenDiscountHandling === brokenDiscountHandlingValues.chargeFee ? brokenDiscountBonusEnabled : false,
    broken_discount_custom_message_enabled: brokenDiscountCustomMessageEnabled,
    broken_discount_custom_message: brokenDiscountCustomMessage,
    exchange_payment_expiration_delta:
      issueExchangeAtStatus === issueExchangeStatus.inProgress ? exchangePaymentExpiration || 1 : 1,
    instant_exchange_payment_expiration_delta: instantExchangePaymentExpiration || 1,
    allows_gift_returns: allowsGiftReturns,
    skip_identifier_validation: skipIdentifierValidation,
  }
}

export const allowedExchangeMethodsIncludesSomeVariantsType = allowedExchangeMethods => {
  return (
    allowedExchangeMethods?.includes(exchangeMethods.sameProductVariants) ||
    allowedExchangeMethods?.includes(exchangeMethods.otherProductVariants)
  )
}

export const isFormValid = ({
  allowReturns,
  maxDurationForRefund,
  allowExchanges,
  maxDurationForExchanges,
  allowReturnCancelDeadline,
  returnCancelDeadlineDays,
  exchangePaymentExpiration,
  instantExchangePaymentExpiration,
  brokenDiscountHandling,
  brokenDiscountCustomMessageEnabled,
  brokenDiscountCustomMessage,
  brokenDiscountCustomMessageLanguages,
}) => {
  const isRefundValid = !allowReturns || maxDurationForRefund?.length > 0
  const isExchangeValid = !allowExchanges || maxDurationForExchanges?.length > 0
  const isReturnCancelDeadlineDaysValid =
    !allowReturnCancelDeadline ||
    (Number(returnCancelDeadlineDays) > 0 && Number(returnCancelDeadlineDays) <= MAX_RETURN_CANCEL_DEADLINE_DAYS)

  const isValidExchangePaymentExpiration = exchangePaymentExpiration
    ? Number(exchangePaymentExpiration) > 0 && Number(exchangePaymentExpiration) <= 48
    : true
  const isValidInstantExchangePaymentExpiration = instantExchangePaymentExpiration
    ? Number(instantExchangePaymentExpiration) > 0 && Number(instantExchangePaymentExpiration) <= 48
    : false
  const isBrokenDiscountCustomMessageValid =
    brokenDiscountHandling !== brokenDiscountHandlingValues.chargeFee ||
    !brokenDiscountCustomMessageEnabled ||
    (brokenDiscountCustomMessageLanguages || []).every(
      language => !isHtmlContentEmpty(brokenDiscountCustomMessage?.[language])
    )

  return (
    isRefundValid &&
    isExchangeValid &&
    isReturnCancelDeadlineDaysValid &&
    isValidExchangePaymentExpiration &&
    isValidInstantExchangePaymentExpiration &&
    isBrokenDiscountCustomMessageValid
  )
}
